import { render, staticRenderFns } from "./IconCode.vue?vue&type=template&id=38b88a87&"
import script from "./IconCode.vue?vue&type=script&lang=js&"
export * from "./IconCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports